export default __webpack_public_path__ + "static/media/Not_Found.1af401e8.gif";